/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlanDto } from '../../models/plan-dto';
import { UpdatePlanRequest } from '../../models/update-plan-request';

export interface BillingPlansPlanIdPut$Json$Params {
  planId: string;
      body?: UpdatePlanRequest
}

export function billingPlansPlanIdPut$Json(http: HttpClient, rootUrl: string, params: BillingPlansPlanIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PlanDto>> {
  const rb = new RequestBuilder(rootUrl, billingPlansPlanIdPut$Json.PATH, 'put');
  if (params) {
    rb.path('planId', params.planId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlanDto>;
    })
  );
}

billingPlansPlanIdPut$Json.PATH = '/billing/plans/{planId}';
